import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function MangueirasPage() {
  useSeo({
    title: 'Mangueiras Hidráulicas Industriais | Duraflow',
    description: 'Mangueiras hidráulicas de alta pressão, termoplásticas, especiais e conjuntos montados para sistemas industriais, agrícolas e móveis.',
    keywords: 'mangueiras hidráulicas, mangueiras de alta pressão, conjuntos montados, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/mangueiras-hidraulicas',
    ogUrl: 'https://www.pilarmanutencao.com.br/mangueiras-hidraulicas',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MANGUEIRAS-HIDRAULICAS/CARD/MANGUEIRAS-HIDRAULICAS.webp',
  });

  return (
    <DuraflowCategoryPage
      title="Mangueiras Hidráulicas"
      subtitle="Soluções sob medida para condução de óleo sob pressão em sistemas industriais, agrícolas e móveis."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MANGUEIRAS-HIDRAULICAS/HERO/HERO-MANGUEIRAS-HIDRAULICAS.webp"
      heroImageAlt="Mangueiras hidráulicas industriais de alta pressão"
      description="As mangueiras hidráulicas são componentes essenciais para conduzir fluido hidráulico sob pressão entre bombas, válvulas, cilindros, motores e demais partes do sistema. A escolha correta da mangueira garante segurança, durabilidade e desempenho na operação."
      applications={[
        'Mangueiras hidráulicas de alta pressão',
        'Mangueiras para óleo hidráulico',
        'Mangueiras para máquinas industriais',
        'Mangueiras para equipamentos móveis',
        'Mangueiras montadas com terminais prensados',
        'Mangueiras sob medida',
        'Reposição de linhas hidráulicas',
        'Identificação por amostra, medida ou aplicação',
      ]}
      applicationsTitle="Soluções atendidas"
      types={[
        {
          title: 'Mangueiras de Alta Pressão',
          description:
            'Linha completa de mangueiras SAE 100R1, R2, R12, R13 e R15, com pressões de trabalho que atendem desde sistemas leves até aplicações ultra-high pressure.',
        },
        {
          title: 'Mangueiras Termoplásticas',
          description:
            'Mangueiras termoplásticas de alta performance para aplicações que exigem flexibilidade superior e resistência química em ambientes agressivos.',
        },
        {
          title: 'Mangueiras Especiais',
          description:
            'Mangueiras com revestimentos resistentes a temperatura extrema, produtos químicos, abrasão e para aplicações subaquáticas ou de alta pureza.',
        },
        {
          title: 'Conjuntos Montados',
          description:
            'Conjuntos de mangueiras pré-montadas com terminais cravados ou engatados, prontos para instalação com certificado de teste hidrostático.',
        },
        {
          title: 'Acessórios e Terminais',
          description:
            'Terminais em aço carbono, inox e latão, abraçadeiras, protetores de mola e toda a linha de conexão para mangueiras hidráulicas.',
        },
        {
          title: 'Manutenção e Recertificação',
          description:
            'Serviço de inspeção, teste de pressão e recertificação de mangueiras hidráulicas conforme normas técnicas e requisitos de segurança.',
        },
      ]}
      differentials={[
        'Atendimento técnico especializado',
        'Fornecimento sob consulta',
        'Apoio na identificação de componentes',
        'Análise da aplicação',
        'Alternativas compatíveis',
        'Cotação rápida via WhatsApp',
        'Suporte para manutenção industrial',
        'Soluções para reposição e novos projetos',
      ]}
      differentialsTitle="Diferenciais Duraflow"
      midCTA={{
        title: 'Precisa substituir ou montar uma mangueira hidráulica?',
        text: 'Envie foto, medida, terminal ou aplicação para nossa equipe técnica.',
        buttonText: 'Falar com especialista',
      }}
      ctaTitle="Precisa de uma solução hidráulica?"
      ctaText="Envie sua demanda para nossa equipe técnica. Podemos ajudar na identificação, cotação e fornecimento do componente mais adequado para sua aplicação."
      ctaButtonText="Chamar no WhatsApp"
    />
  );
}